var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignagePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H8.33333C8.55435 0 8.76631 0.0877973 8.92259 0.244078L14.7559 6.07741C14.9122 6.23369 15 6.44565 15 6.66667V15.8333C15 16.4964 14.7366 17.1323 14.2678 17.6011C13.7989 18.0699 13.163 18.3333 12.5 18.3333H2.5C1.83696 18.3333 1.20107 18.0699 0.732233 17.6011C0.263392 17.1323 0 16.4964 0 15.8333V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233ZM2.5 1.66667C2.27899 1.66667 2.06702 1.75446 1.91074 1.91074C1.75446 2.06702 1.66667 2.27899 1.66667 2.5V15.8333C1.66667 16.0543 1.75446 16.2663 1.91074 16.4226C2.06702 16.5789 2.27899 16.6667 2.5 16.6667H12.5C12.721 16.6667 12.933 16.5789 13.0893 16.4226C13.2455 16.2663 13.3333 16.0543 13.3333 15.8333V7.5H8.33333C7.8731 7.5 7.5 7.1269 7.5 6.66667V1.66667H2.5ZM9.16667 2.84518L12.1548 5.83333H9.16667V2.84518Z",
    fill: "#696869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignagePlus);
export default __webpack_public_path__ + "static/media/signage-plus.be14a8cb6e3af1a34f68f09054ec30a0.svg";
export { ForwardRef as ReactComponent };